module.exports = __webpack_public_path__ + "img/preview_electrocactus.a52dd79f.png";